module.exports = __webpack_public_path__ + "img/home.86de23cd.svg";